import { useEffect, useState } from "react";
import {
  Avatar,
  Button,
  Checkbox,
  Col,
  DatePicker,
  Divider,
  Empty,
  List,
  Modal,
  Popover,
  Row,
  Space,
  Tag,
} from "antd";
import { DownOutlined } from "@ant-design/icons";
import { inboxList } from "./Data";
import "./CardInbox.css";
import ModalContent from "./ModalContent";
import { collection, doc, getDocs, updateDoc } from "firebase/firestore";
import { auth, db } from "../../../../firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import Title from "antd/es/skeleton/Title";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";

function UpComingTasks({ upcomingTasks }) {
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [visible, setVisible] = useState(false);

  const navigate = useNavigate();

  console.log("selectedCheckboxes", selectedCheckboxes);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalId, setModalId] = useState(null);

  const showModal = (id) => {
    setIsModalOpen(true);
    setModalId(id);
  };

  const handleCheckboxChange = (docId) => {
    setSelectedCheckboxes((prev) => {
      if (prev.includes(docId)) {
        return prev.filter((id) => id !== docId);
      } else {
        return [...prev, docId];
      }
    });
  };

  const handleSelectAllChange = (e) => {
    if (e.target.checked) {
      const allTasksDocIds = [...upcomingTasks].map((item) => item.docId);
      setSelectedCheckboxes(allTasksDocIds);
    } else {
      setSelectedCheckboxes([]);
    }
    setSelectAllChecked(e.target.checked);
  };

  const onChange = (value, dateString) => {};

  const onOk = (value) => {
    console.log("onOk: ", value);
  };

  const getTimes = () => {
    const now = new Date();

    // Later today (5 hours from now)
    const laterToday = new Date(now.getTime() + 5 * 60 * 60 * 1000);

    // Tomorrow (24 hours from now)
    const tomorrow = new Date(now.getTime() + 24 * 60 * 60 * 1000);

    // Later this week (Upcoming Friday)
    const laterThisWeek = new Date(now);
    if (now.getDay() !== 5) {
      // If today isn't Friday
      laterThisWeek.setDate(now.getDate() + (5 - now.getDay()));
    } else {
      // If today is already Friday, set to the next Friday
      laterThisWeek.setDate(now.getDate() + 7);
    }
    laterThisWeek.setHours(8, 0, 0);

    // Next week (7 days from now)
    const nextWeek = new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000);
    nextWeek.setHours(8, 0, 0);

    return {
      laterToday,
      tomorrow,
      laterThisWeek,
      nextWeek,
    };
  };

  const times = getTimes();

  const runModal = (
    <div>
      <Row gutter={16} justify="center">
        <Col>SNOOZE UNTIL...</Col>
      </Row>
      <Divider style={{ margin: "5px 0" }} />
      <Row gutter={16} justify="space-between" className="snoozeListPopover">
        <Col>Later today</Col>
        <Col>{times.laterToday.toLocaleTimeString()}</Col>
      </Row>
      <Row gutter={16} justify="space-between" className="snoozeListPopover">
        <Col>Tomorrow</Col>
        <Col>{times.tomorrow.toLocaleTimeString()}</Col>
      </Row>
      <Row gutter={16} justify="space-between" className="snoozeListPopover">
        <Col>Later this week</Col>
        <Col>{times.laterThisWeek.toLocaleTimeString()}</Col>
      </Row>
      <Row gutter={16} justify="space-between" className="snoozeListPopover">
        <Col>Next week</Col>
        <Col>{times.nextWeek.toLocaleTimeString()}</Col>
      </Row>
      <Divider style={{ margin: "5px 0" }} />
      <Row gutter={16} justify="center">
        <Col>
          <DatePicker
            placeholder="Pick date & time"
            showTime
            onChange={onChange}
            onOk={onOk}
          />
        </Col>
      </Row>
    </div>
  );

  const handleVisibleChange = (visible) => {
    setVisible(visible);
  };

  const handleCheckBoxClick = (e) => {
    // Prevent the item click from being triggered when clicking the checkbox
    e.stopPropagation();
  };

  const getInitials = (name) => {
    return name ? name.substring(0, 2) : "";
  };

  const handleItemPage = (e, id) => {
    // Prevent the item click from being triggered when clicking the checkbox
    e.stopPropagation();
    navigate(`/tasks/inbox/${id}`);
  };

  const handleCompleteStatus = (e, id) => {
    // Prevent the item click from being triggered when clicking the checkbox
    e.stopPropagation();
    const tasksRef = collection(db, "tasks");
    const itemListRef = doc(tasksRef, "itemList");
    const assignedCollectionRef = collection(itemListRef, "Assigned");
    const docToUpdateRef = doc(assignedCollectionRef, id);
    // Update the document
    async function updateDocument() {
      try {
        await updateDoc(docToUpdateRef, {
          // replace with the fields you want to update
          status: "completed",
        });
        console.log("Document successfully updated!");
      } catch (error) {
        console.error("Error updating document:", error);
      }
    }
    updateDocument();
  };

  const handleSelectedCompleted = () => {
    // Prevent the item click from being triggered when clicking the checkbox
    const tasksRef = collection(db, "tasks");
    const itemListRef = doc(tasksRef, "itemList");
    const assignedCollectionRef = collection(itemListRef, "Assigned");
    // Function to update a single document
    const updateDocument = async (id) => {
      const docToUpdateRef = doc(assignedCollectionRef, id); // Get the reference to the specific document
      try {
        await updateDoc(docToUpdateRef, {
          // replace with the fields you want to update
          status: "completed",
        });
        toast.success("successfully updated!");
      } catch (error) {
        console.error(`Error updating document ${id}:`, error);
        toast.error("Error updating document!");
      }
    };

    // Function to update all selectedIds
    const handleCompleteStatusForAllSelected = () => {
      for (const id of selectedCheckboxes) {
        updateDocument(id);
      }
    };

    // Execute the update for all selected IDs
    handleCompleteStatusForAllSelected();
  };

  return (
    <div className="InboxCard">
      <h3>This Week</h3>

      {selectedCheckboxes.length > 0 && (
        <div className="checkBoxBar">
          <Row justify="space-between">
            <Col>
              <Row gutter={16}>
                <Col>
                  <Checkbox
                    checked={selectAllChecked}
                    onChange={handleSelectAllChange}
                  >
                    {selectedCheckboxes.length} Selected
                  </Checkbox>
                </Col>

                <Col>
                  <Button onClick={handleSelectedCompleted}>Complete</Button>
                </Col>

                <Col>
                  <Popover
                    content={runModal}
                    trigger="click"
                    visible={visible}
                    onVisibleChange={handleVisibleChange}
                    placement="bottom"
                  >
                    <Button onClick={(e) => e.preventDefault()}>
                      <Space>
                        Snooze
                        <DownOutlined />
                      </Space>
                    </Button>
                  </Popover>
                </Col>
              </Row>
            </Col>
          </Row>
          <Button>Done</Button>
        </div>
      )}

      <List
        itemLayout="horizontal"
        dataSource={upcomingTasks}
        renderItem={(item, index) => (
          <List.Item
            actions={[
              hoveredIndex === item.docId ||
              selectedCheckboxes.includes(item.docId) ? (
                <div className="listItemAction">
                  <span key="1" onClick={handleCheckBoxClick}>
                    <i className="fa-regular fa-clock listIcons"></i>
                  </span>
                  <span key="2" onClick={(e) => handleItemPage(e, item.docId)}>
                    <i className="fa-solid fa-arrow-up-right-from-square listIcons"></i>
                  </span>
                  <span
                    key="3"
                    onClick={(e) => handleCompleteStatus(e, item.docId)}
                  >
                    <i className="fa-solid fa-square-check listIcons"></i>
                  </span>
                </div>
              ) : (
                <span>
                  <Tag
                    style={{
                      background: "#ebf4fb",
                      color: "#0079ca",
                      fontSize: "12px",
                      lineHeight: "1.6rem",
                      padding: "0px 4px",
                    }}
                  >
                    {item.workFlowRunDueDate}
                  </Tag>
                  {item.workFlowRunAssignee.map((name, index) => (
                    <Avatar key={index}>{getInitials(name)}</Avatar>
                  ))}
                </span>
              ),
            ]}
            onMouseEnter={() => setHoveredIndex(item.docId)}
            onMouseLeave={() => setHoveredIndex(null)}
            style={{ cursor: "pointer" }}
            onClick={() => showModal(item.workFlowRunName)}
          >
            <List.Item.Meta
              avatar={
                <span onClick={handleCheckBoxClick}>
                  {hoveredIndex === item.docId ||
                  selectedCheckboxes.includes(item.docId) ? (
                    <Checkbox
                      onChange={() => handleCheckboxChange(item.docId)}
                      checked={selectedCheckboxes.includes(item.docId)}
                    />
                  ) : (
                    <span>
                      <i className="fa-solid fa-table-list"></i>
                    </span>
                  )}
                </span>
              }
              title={<span>{item.workFlowRunName}</span>}
              description={item.workFlowRunName}
            />
          </List.Item>
        )}
      />

      <ModalContent
        modalId={modalId}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
      />
    </div>
  );
}

export default UpComingTasks;
